import { render, staticRenderFns } from "./ReminderPlanForm.vue?vue&type=template&id=a4092924&"
import script from "./ReminderPlanForm.vue?vue&type=script&lang=js&"
export * from "./ReminderPlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports